import type { SymbolKey } from '@/entities/symbol';
import type { CatalogItem } from '@/pages/Catalog/types';

import type { Row } from '@tanstack/react-table';

export const parseForwardCurveRowToSymbol = (row: Row<CatalogItem>) => {
  const periodMin = row.getValue<number>('PeriodMin');
  const periodMax = row.getValue<number>('PeriodMax');
  const baseSymbol = row.getValue<SymbolKey>('Symbol');
  const selectedSymbols: SymbolKey[] = [];
  if (baseSymbol) {
    for (let i = periodMin; i <= periodMax; i++) {
      selectedSymbols.push({
        Code: baseSymbol.Code,
        TimeRef: baseSymbol.TimeRef,
        Period: i.toString(),
        PeriodType: baseSymbol.PeriodType
      });
    }
  }
  return selectedSymbols;
};
